<p-tabView *ngIf="entidade">
  <p-tabPanel header="Órgão julgador">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Id:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="id" disabled [ngModel]="entidade.id" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Orgão Justiça:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="orgaoJusticaNome" disabled [ngModel]="entidade.orgaoJustica.nome" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Jurisdição:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-dropdown
            placeholder="Favor selecionar a jurisdição"
            [options]="jurisdicaoItens"
            optionLabel= "nome"
            dataKey="id"
            filter="true"
            [(ngModel)]="entidade.jurisdicao">
          </p-dropdown>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Nome:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="nome" disabled [(ngModel)]="entidade.nome" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label>Instância:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-selectButton [options]="instanciaItens" [(ngModel)]="entidade.instancia"></p-selectButton>
        </div>
      </div>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Auditoria" [disabled]="entidade.id === undefined">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-3">Inserção - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3">Inserção - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuarioInsercao?.nome}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3">Última alteração - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3">Última alteração - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuario?.nome}}</div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
